import useIsMobile from '~/hooks/useIsMobile';
import DesktopBenefits from './partials/DesktopBenefits';
import MobileBenefits from './partials/MobileBenefits';

/**
 * @param {BenefitsProps} props
 */
const Benefits = ({ items, title }) => {
  const isMobile = useIsMobile({ contextKey: 'jobTeaser' });

  if (!isMobile) {
    return <DesktopBenefits items={items} title={title} />;
  }
  return <MobileBenefits items={items} title={title} />;
};

export default Benefits;
